import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId });
        if (data.mfa_required) {
          sessionStorage.setItem("pending_mfa_token", data.mfa_token);
          navigate("/login");
          return;
        }
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard");
      } catch (e) {
        const detail = e?.response?.data?.detail;
        const msg = typeof detail === "string" ? detail : "Google sign-in failed. Please try again.";
        navigate(`/login?google_error=${encodeURIComponent(msg)}`);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-slate-500 text-sm">Signing you in…</div>
    </div>
  );
}
